{
  "spec": {
    "type": "`U`&`G`",
    "name": "untitled",
    "units": {
      "fetch": {
        "id": "c5856fdc-5154-46ab-a414-47f37af39da1",
        "input": {
          "url": {
            "constant": true,
            "data": { "ref": [], "data": "https://ioun.it/random" }
          },
          "opt": {
            "constant": true,
            "data": {
              "ref": [],
              "data": { "headers": { "Accept": "application/json" } }
            }
          }
        },
        "output": { "res": {} },
        "metadata": { "position": { "x": -318, "y": 0 } }
      },
      "parseJSONbody": {
        "id": "63ede222-07af-4b27-98bc-d8bc7cc5b14c",
        "input": { "res": {} },
        "output": { "json": {} },
        "metadata": { "position": { "x": -214, "y": 0 } }
      },
      "frombundle": {
        "id": "de2d42e2-4fca-4a3f-8783-3585c546e88b",
        "input": { "bundle": {} },
        "output": { "graph": {} },
        "metadata": { "position": { "x": -113, "y": 0 } }
      },
      "IO": {
        "id": "6f267de2-b02c-11ea-b55c-db553f4c6c45",
        "input": {
          "disabled": { "ignored": true },
          "style": { "ignored": true },
          "graph": {},
          "fullwindow": { "ignored": true },
          "frame": { "ignored": true },
          "d": { "ignored": true }
        },
        "output": {
          "graph": { "ignored": true },
          "state": { "ignored": true }
        },
        "metadata": { "position": { "x": 152, "y": 0 } }
      }
    },
    "merges": {
      "0": {
        "parseJSONbody": { "input": { "res": true } },
        "fetch": { "output": { "res": true } }
      },
      "1": {
        "frombundle": { "input": { "bundle": true } },
        "parseJSONbody": { "output": { "json": true } }
      },
      "2": {
        "IO": { "input": { "graph": true } },
        "frombundle": { "output": { "graph": true } }
      }
    },
    "inputs": {},
    "outputs": {},
    "metadata": {
      "icon": null,
      "description": "",
      "position": {
        "merge": {
          "0": { "x": -266, "y": 0 },
          "1": { "x": -163, "y": 0 },
          "2": { "x": -63, "y": 0 }
        }
      }
    },
    "id": "45ea2346-151d-4a63-b9cd-4cc616ae4237",
    "component": { "children": ["IO"], "subComponents": { "IO": {} } }
  },
  "specs": {}
}
